import { Vue, Component, Prop } from 'vue-property-decorator';
import { ScreenText } from '@/lang/ScreenText';
import Spinner from '../spinner/Spinner.vue';
import APP_CONST from '@/constants/AppConst';

const baseSpinnerRatio = 3.2667;

@Component(
  {
    components: {
      Spinner
    }
  }
)
export class BouncingPreloaderComponent extends Vue {
  @Prop({ type: Number, default: baseSpinnerRatio }) spinnerRatio!: number;
  @Prop({ type: String, default: APP_CONST.STYLE.COLOR.PRIMARY_700 }) spinnerColor!: string;
  @Prop({ type: Number, default: 1.5 }) spinnerThickness!: number;
  @Prop({ type: Number, default: 40 }) marginTop!: number;
  @Prop({ type: String, default: 'column' }) flexDirection!: string;
  @Prop({ type: Boolean, default: false }) hideLoadingText!: boolean;

  private screenText: ScreenText = new ScreenText();

  public getScreenText(key: string): string {
    return this.screenText.getScreenText(key);
  }

  get formattedFontSize(): string {
    const fontSize = 24 * (this.spinnerRatio / baseSpinnerRatio);
    const clampedFontSize = Math.max(12, Math.min(fontSize, 48));
    return clampedFontSize.toString();
  }
}